var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "seal-wrapper" }, [
    _c("img", { staticClass: "blind_seal", attrs: { src: _vm.icon } }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }